<template>
   <div v-if="categories">
    <div class="industury__topbanner">
      <ul v-if="$root.globalData">
        <li>{{$root.globalData.keys.category_text}}</li>
        <span> <DoubleLeftAroow /> </span>
        <li>
          <router-link style="color: white" to="/"> {{$root.globalData.keys.home_index_text}} </router-link>
        </li>
      </ul>
    </div>
  <div id="categories" >
    <router-link
      class="categoryItem"
      :to="`/industry?categoryIds=${category.id}}}`"
      v-for="(category, index) in categories"
      :key="index"
    >
      <img :src="category.image" :alt="category.title" />
      <h3>{{ category.title }}</h3>
    </router-link>
  </div>
   </div>
  <loader v-else />
</template>
<script>
import DoubleLeftAroow from "../components/svgs/DoubleLeftAroow.vue";

import Loader from "../components/loader.vue";
export default {
  components: { Loader ,DoubleLeftAroow},
  data() {
    return {
      categories: null,
    };
  },
  mounted() {
    if (this.categories == null) {
      this.$axios.get("front/unitFilters").then((res) => {
        this.categories = res.data.filters.categories;
      });
    }
  },
  
  metaInfo() {
        return { 
            title: "دسته بندی ها",
            meta: [
                { name: 'description', content:  'دسته بندی ها'},
                { property: 'og:title', content: "دسته بندی ها"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>
<style>
div#categories {
  grid-template-columns: repeat(5, 1fr);
  width: 95%;
  margin: auto;
  box-shadow: 0 0 5px #00000015;
  border-radius: 10px;
  padding: 20px;
  display: grid;
  gap: 15px;
  direction: rtl;
  margin-top: 10px;
}
a.categoryItem img {
  width: 100%;
  height: 150px;
}
a.categoryItem {
  padding: 5px;
  box-shadow: 0 0 5px #00000065;
  border-radius: 5px;
  color: black !important;
}
a.categoryItem h3 {
  height: 70px;
  font-weight: 600;
}
.ltrStyle div#categories {
  direction: ltr;
}
@media (max-width: 1000px) {
  div#categories {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 768px) {
  div#categories {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 580px) {
  div#categories {
    grid-template-columns: repeat(2, 1fr);
  }
  a.categoryItem h3{
      font-size: 16px;
  }
}
.industury__topbanner {
  width: 100%;
  height: 200px;
  background-image: url(../assets/images/industrybanner.jpg);
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

  .industury__topbanner ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

  .industury__topbanner ul li {
  font-size: 20px;
  cursor: pointer;
}
@media only screen and (max-width: 1155px) {
  .industury__topbanner {
    display: none;
  }
}
</style>
